import { render } from "./PlanetaryTrack.vue?vue&type=template&id=526aebe3&ts=true"
import script from "./PlanetaryTrack.vue?vue&type=script&lang=ts"
export * from "./PlanetaryTrack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__